import React from "react";
import ReactDOM from "react-dom";
import MaterialIcon from "./MaterialIcon";
import "./ProjectConfirmModal.css";

/**
 * ProjectConfirmModal
 *
 * Shown when a user types a project/room name that is *very close* to an
 * existing one (see projectMatch.findCloseProject). Rather than silently
 * creating a near-duplicate room, we ask them to confirm: use the existing
 * match, or create the new name they typed anyway. Reuses .email-classify-*
 * modal styles.
 */
function ProjectConfirmModal({ typedName, suggestion, onUseExisting, onCreateNew, onClose, strings = {} }) {
  return ReactDOM.createPortal(
    <div className="email-classify-overlay email-classify-overlay--portal" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="email-classify-modal" onClick={(e) => e.stopPropagation()}>
        <div className="email-classify-header">
          <div className="email-classify-title">
            <MaterialIcon icon="help" size={20} color="#e066ed" />
            <span>{strings.project_confirm_title || "Did you mean this project?"}</span>
          </div>
          <button className="kj-btn kj-btn--icon kj-btn--sm kj-btn--neutral" onClick={onClose} title={strings.cancel || "Close"}>
            <MaterialIcon icon="close" size={18} />
          </button>
        </div>

        <div className="email-classify-section">
          <div className="email-classify-question project-confirm-modal__question">
            {(strings.project_confirm_text ||
              'The name "{typed}" is very similar to the existing project "{existing}". Do you want to use the existing project, or create a new one?')
              .replace("{typed}", typedName || "")
              .replace("{existing}", (suggestion && suggestion.name) || "")}
          </div>
          <button className="kj-btn kj-btn--primary kj-btn--email kj-btn--block email-classify-btn" onClick={onUseExisting}>
            <MaterialIcon icon="folder" size={16} />
            <span>
              {(strings.project_confirm_use_existing || 'Use "{name}"').replace(
                "{name}",
                (suggestion && suggestion.name) || ""
              )}
            </span>
          </button>
          <button className="kj-btn kj-btn--secondary kj-btn--block email-classify-btn mt-2" onClick={onCreateNew}>
            <MaterialIcon icon="add" size={16} />
            <span>
              {(strings.project_confirm_create_new || 'Create new "{name}"').replace("{name}", typedName || "")}
            </span>
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default ProjectConfirmModal;
